var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isFalsy, isValidNumber } from '../../../../utils/common';
import { EnglishExamStatusEnum, GRADING_SCHEME } from '../utils';
import { transformOptionValues } from './cfFilterCommonUtils';
import { EnglishExamTestTypes } from './types';
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var CfEligibilityUtil = /** @class */ (function () {
    function CfEligibilityUtil() {
    }
    // Function not in use
    CfEligibilityUtil.getCFEligibilityAcademicData = function (gradeSystem, academinInfo) {
        var _a, _b, _c;
        var eligibilityAcademicData = {};
        // ugExam  -> start
        var ugExamData = (_a = academinInfo === null || academinInfo === void 0 ? void 0 : academinInfo.academicInfoDetails) === null || _a === void 0 ? void 0 : _a.find(function (academicDetail) { return (academicDetail === null || academicDetail === void 0 ? void 0 : academicDetail.courseType) === 'BACHELORS_DEGREE'; });
        eligibilityAcademicData.ugGrade = ugExamData === null || ugExamData === void 0 ? void 0 : ugExamData.grade;
        var ugGradeSystem = gradeSystem.find(function (system) { return (system === null || system === void 0 ? void 0 : system.labelKey) === (ugExamData === null || ugExamData === void 0 ? void 0 : ugExamData.gradeSystem); });
        if (!isFalsy(ugGradeSystem)) {
            eligibilityAcademicData.ugGradingScheme = {
                label: ugGradeSystem === null || ugGradeSystem === void 0 ? void 0 : ugGradeSystem.labelValue,
                value: ugGradeSystem === null || ugGradeSystem === void 0 ? void 0 : ugGradeSystem.labelKey
            };
        }
        else if (!isFalsy(eligibilityAcademicData.ugGrade)) {
            eligibilityAcademicData.ugGradingScheme = {
                label: 'Percentage',
                value: GRADING_SCHEME.PERCENTAGE
            };
        }
        eligibilityAcademicData.ugBacklogs = ugExamData === null || ugExamData === void 0 ? void 0 : ugExamData.backLogs;
        // ugExam  -> end
        // pgExam  -> start
        var pgExamData = (_b = academinInfo === null || academinInfo === void 0 ? void 0 : academinInfo.academicInfoDetails) === null || _b === void 0 ? void 0 : _b.find(function (academicDetail) { return (academicDetail === null || academicDetail === void 0 ? void 0 : academicDetail.courseType) === 'MASTERS_DEGREE'; });
        eligibilityAcademicData.pgGrade = pgExamData === null || pgExamData === void 0 ? void 0 : pgExamData.grade;
        var pgGradeSystem = gradeSystem.find(function (system) { return (system === null || system === void 0 ? void 0 : system.labelValue) === (pgExamData === null || pgExamData === void 0 ? void 0 : pgExamData.gradeSystem); });
        if (!isFalsy(pgGradeSystem)) {
            eligibilityAcademicData.pgGradingScheme = {
                label: pgGradeSystem === null || pgGradeSystem === void 0 ? void 0 : pgGradeSystem.labelValue,
                value: pgGradeSystem === null || pgGradeSystem === void 0 ? void 0 : pgGradeSystem.labelValue
            };
        }
        else if (!isFalsy(eligibilityAcademicData.pgGrade)) {
            eligibilityAcademicData.pgGradingScheme = {
                label: 'Percentage',
                value: GRADING_SCHEME.PERCENTAGE
            };
        }
        // pgExam  -> end
        // twelfthDiploma -> start
        var twelfthDiplomaData = (_c = academinInfo === null || academinInfo === void 0 ? void 0 : academinInfo.academicInfoDetails) === null || _c === void 0 ? void 0 : _c.find(function (academicDetail) {
            return (academicDetail === null || academicDetail === void 0 ? void 0 : academicDetail.courseType) === 'TWELFTH' || (academicDetail === null || academicDetail === void 0 ? void 0 : academicDetail.courseType) === 'DIPLOMA';
        });
        eligibilityAcademicData.twelfthGrade = twelfthDiplomaData === null || twelfthDiplomaData === void 0 ? void 0 : twelfthDiplomaData.grade;
        var twelfthDiplomaGradeSystem = gradeSystem.find(function (system) { return (system === null || system === void 0 ? void 0 : system.labelKey) === (twelfthDiplomaData === null || twelfthDiplomaData === void 0 ? void 0 : twelfthDiplomaData.gradeSystem); });
        if (!isFalsy(twelfthDiplomaGradeSystem)) {
            eligibilityAcademicData.twelfthGradingScheme = {
                label: twelfthDiplomaGradeSystem === null || twelfthDiplomaGradeSystem === void 0 ? void 0 : twelfthDiplomaGradeSystem.labelValue,
                value: twelfthDiplomaGradeSystem === null || twelfthDiplomaGradeSystem === void 0 ? void 0 : twelfthDiplomaGradeSystem.labelKey
            };
        }
        else if (!isFalsy(eligibilityAcademicData.twelfthGrade)) {
            eligibilityAcademicData.twelfthGradingScheme = {
                label: 'Percentage',
                value: GRADING_SCHEME.PERCENTAGE
            };
        }
        // twelfthDiploma -> end
        eligibilityAcademicData.yearsOfEducation = academinInfo === null || academinInfo === void 0 ? void 0 : academinInfo.yearsOfEducation;
        eligibilityAcademicData.universityNaac = ugExamData === null || ugExamData === void 0 ? void 0 : ugExamData.universityNaac;
        if ((twelfthDiplomaData === null || twelfthDiplomaData === void 0 ? void 0 : twelfthDiplomaData.boardCode) && (twelfthDiplomaData === null || twelfthDiplomaData === void 0 ? void 0 : twelfthDiplomaData.boardName)) {
            eligibilityAcademicData.twelfthBoardCode = {
                value: twelfthDiplomaData === null || twelfthDiplomaData === void 0 ? void 0 : twelfthDiplomaData.boardCode,
                label: twelfthDiplomaData === null || twelfthDiplomaData === void 0 ? void 0 : twelfthDiplomaData.boardName
            };
        }
        if ((ugExamData === null || ugExamData === void 0 ? void 0 : ugExamData.universityCode) && (ugExamData === null || ugExamData === void 0 ? void 0 : ugExamData.university)) {
            eligibilityAcademicData.ugUniversityCode = {
                value: ugExamData === null || ugExamData === void 0 ? void 0 : ugExamData.universityCode,
                label: ugExamData === null || ugExamData === void 0 ? void 0 : ugExamData.university
            };
        }
        if (twelfthDiplomaData === null || twelfthDiplomaData === void 0 ? void 0 : twelfthDiplomaData.graduationYear) {
            eligibilityAcademicData.twelfthGraduationYear = {
                value: twelfthDiplomaData === null || twelfthDiplomaData === void 0 ? void 0 : twelfthDiplomaData.graduationYear.toString(),
                label: twelfthDiplomaData === null || twelfthDiplomaData === void 0 ? void 0 : twelfthDiplomaData.graduationYear.toString()
            };
        }
        if (twelfthDiplomaData === null || twelfthDiplomaData === void 0 ? void 0 : twelfthDiplomaData.englishGrade) {
            eligibilityAcademicData.twelfthEnglishGrade = twelfthDiplomaData === null || twelfthDiplomaData === void 0 ? void 0 : twelfthDiplomaData.englishGrade;
        }
        return eligibilityAcademicData;
    };
    // Function not in use
    CfEligibilityUtil.getCFEligibilityExamInfoData = function (examOptions, examInfoData) {
        var _a, _b, _c;
        var eligibilityExamInfoData = {};
        var englishExamData = (_a = examInfoData === null || examInfoData === void 0 ? void 0 : examInfoData.examInfoDetails) === null || _a === void 0 ? void 0 : _a.find(function (examDetail) { return (examDetail === null || examDetail === void 0 ? void 0 : examDetail.examType) === (examInfoData === null || examInfoData === void 0 ? void 0 : examInfoData.englishExamType); });
        eligibilityExamInfoData.englishExamGiven = examInfoData === null || examInfoData === void 0 ? void 0 : examInfoData.englishExamGiven;
        eligibilityExamInfoData.englishExamType = examOptions.englishExamOptions.find(function (option) { return option.value === (englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.examType); });
        eligibilityExamInfoData.listening = englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.listeningScore;
        eligibilityExamInfoData.reading = englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.readingScore;
        eligibilityExamInfoData.writing = englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.writingScore;
        eligibilityExamInfoData.speaking = englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.speakingScore;
        eligibilityExamInfoData.literacy = englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.literacy;
        eligibilityExamInfoData.production = englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.production;
        eligibilityExamInfoData.comprehension = englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.comprehension;
        eligibilityExamInfoData.conversation = englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.conversation;
        eligibilityExamInfoData.englishTotalScore = englishExamData === null || englishExamData === void 0 ? void 0 : englishExamData.totalScore;
        eligibilityExamInfoData.gmatGiven = examInfoData === null || examInfoData === void 0 ? void 0 : examInfoData.gmatExamGiven;
        eligibilityExamInfoData.greGiven = examInfoData === null || examInfoData === void 0 ? void 0 : examInfoData.greExamGiven;
        var greExamData = (_b = examInfoData === null || examInfoData === void 0 ? void 0 : examInfoData.examInfoDetails) === null || _b === void 0 ? void 0 : _b.find(function (examDetail) { return (examDetail === null || examDetail === void 0 ? void 0 : examDetail.examType) === 'GRE'; });
        var gmatExamData = (_c = examInfoData === null || examInfoData === void 0 ? void 0 : examInfoData.examInfoDetails) === null || _c === void 0 ? void 0 : _c.find(function (examDetail) { return (examDetail === null || examDetail === void 0 ? void 0 : examDetail.examType) === 'GMAT'; });
        if (examInfoData === null || examInfoData === void 0 ? void 0 : examInfoData.gmatExamGiven) {
            eligibilityExamInfoData.gmatQuant = gmatExamData === null || gmatExamData === void 0 ? void 0 : gmatExamData.gmatQuantitativeScore;
            eligibilityExamInfoData.gmatScore = gmatExamData === null || gmatExamData === void 0 ? void 0 : gmatExamData.totalScore;
            eligibilityExamInfoData.gmatVerbal = gmatExamData === null || gmatExamData === void 0 ? void 0 : gmatExamData.gmatVerbalScore;
        }
        if (examInfoData === null || examInfoData === void 0 ? void 0 : examInfoData.greExamGiven) {
            eligibilityExamInfoData.greQuant = greExamData === null || greExamData === void 0 ? void 0 : greExamData.greQuantScore;
            eligibilityExamInfoData.greScore = greExamData === null || greExamData === void 0 ? void 0 : greExamData.totalScore;
            eligibilityExamInfoData.greVerbal = greExamData === null || greExamData === void 0 ? void 0 : greExamData.greVerbalScore;
        }
        return eligibilityExamInfoData;
    };
    CfEligibilityUtil.getCfEligibilityValuesForStudent = function (examOptions, student, getOnboardingDataCallback, onBoardingDataUnsubscribeCallback) {
        return __awaiter(this, void 0, void 0, function () {
            var eligibilityData, gradeSystem, onBoardingData, academicEligibilityData, testEligbilityData, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        eligibilityData = {};
                        gradeSystem = [
                            {
                                labelValue: 'CGPA',
                                labelKey: 'CGPA'
                            },
                            {
                                labelValue: 'Percentage',
                                labelKey: 'PERCENTAGE'
                            },
                            {
                                labelValue: '0 to 4',
                                labelKey: 'ZERO_TO_FOUR'
                            }
                        ];
                        // student
                        eligibilityData.student = student;
                        if (isFalsy(student) || isFalsy(student === null || student === void 0 ? void 0 : student.value) || Number.isNaN(Number(student === null || student === void 0 ? void 0 : student.value)))
                            return [2 /*return*/, eligibilityData];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getOnboardingDataCallback(student === null || student === void 0 ? void 0 : student.value)];
                    case 2:
                        onBoardingData = _a.sent();
                        academicEligibilityData = CfEligibilityUtil.getCFEligibilityAcademicData(gradeSystem, onBoardingData === null || onBoardingData === void 0 ? void 0 : onBoardingData.academicInfo);
                        eligibilityData = __assign(__assign({}, eligibilityData), academicEligibilityData);
                        testEligbilityData = CfEligibilityUtil.getCFEligibilityExamInfoData(examOptions, onBoardingData === null || onBoardingData === void 0 ? void 0 : onBoardingData.examInfo);
                        eligibilityData = __assign(__assign({}, eligibilityData), testEligbilityData);
                        onBoardingDataUnsubscribeCallback(student === null || student === void 0 ? void 0 : student.value);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log('Error is getting eligibility values from onboarading data', error_1);
                        return [2 /*return*/, eligibilityData];
                    case 4: return [2 /*return*/, eligibilityData];
                }
            });
        });
    };
    CfEligibilityUtil.getCfEligbilityPayload = function (eligibilityValues) {
        var _a, _b, _c;
        var eligibilityFormValues = {
            backlog: undefined,
            englishExamMinBand: undefined,
            englishExamScore: undefined,
            englishExamType: undefined,
            twelfth_score_100: undefined,
            twelfth_score_10: undefined,
            twelfth_score_4: undefined,
            ug_score_100: undefined,
            ug_score_10: undefined,
            ug_score_4: undefined,
            englishExamGiven: undefined,
            englishExamComprehension: undefined,
            englishExamConversation: undefined,
            englishExamLiteracy: undefined,
            englishExamProduction: undefined,
            englishExamReading: undefined,
            englishExamWriting: undefined,
            englishExamSpeaking: undefined,
            englishExamListening: undefined,
            greQuant: undefined,
            greScore: undefined,
            greVerbal: undefined,
            gmatQuant: undefined,
            gmatScore: undefined,
            gmatVerbal: undefined,
            gmatGiven: undefined,
            greGiven: undefined,
            yearsOfEducation: undefined,
            studentCountryId: undefined,
            studentStateId: undefined,
            universityNaac: undefined,
            twelfthBoardCode: undefined,
            twelfthGraduationYear: undefined,
            ugUniversityCode: undefined,
            twelfthEnglishScore4: undefined,
            twelfthEnglishScore10: undefined,
            twelfthEnglishScore100: undefined,
            moiAccepted: undefined
        };
        if (isFalsy(eligibilityValues) || typeof eligibilityValues === 'undefined')
            return eligibilityFormValues;
        var transformedEligibilityValues = transformOptionValues(eligibilityValues);
        var twelfthGradingScheme = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.twelfthGradingScheme;
        if (!isFalsy(twelfthGradingScheme)) {
            switch (twelfthGradingScheme) {
                case 'ZERO_TO_FOUR':
                    eligibilityFormValues.twelfth_score_4 = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.twelfthGrade;
                    break;
                case 'CGPA':
                    eligibilityFormValues.twelfth_score_10 = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.twelfthGrade;
                    break;
                case 'PERCENTAGE':
                    eligibilityFormValues.twelfth_score_100 = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.twelfthGrade;
                    break;
                default:
                    eligibilityFormValues.twelfth_score_10 = undefined;
                    eligibilityFormValues.twelfth_score_100 = undefined;
                    eligibilityFormValues.twelfth_score_4 = undefined;
                    break;
            }
        }
        var twelfthEnglishGradingScheme = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.twelfthEnglishGradingScheme;
        if (!isFalsy(twelfthEnglishGradingScheme)) {
            switch (twelfthEnglishGradingScheme) {
                case 'ZERO_TO_FOUR':
                    eligibilityFormValues.twelfthEnglishScore4 = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.twelfthEnglishGrade;
                    break;
                case 'CGPA':
                    eligibilityFormValues.twelfthEnglishScore10 = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.twelfthEnglishGrade;
                    break;
                case 'PERCENTAGE':
                    eligibilityFormValues.twelfthEnglishScore100 = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.twelfthEnglishGrade;
                    break;
                default:
                    eligibilityFormValues.twelfthEnglishScore10 = undefined;
                    eligibilityFormValues.twelfthEnglishScore100 = undefined;
                    eligibilityFormValues.twelfthEnglishScore4 = undefined;
                    break;
            }
        }
        var ugGradingScheme = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.ugGradingScheme;
        if (!isFalsy(ugGradingScheme)) {
            switch (ugGradingScheme) {
                // [TODO]: backend need to add zero to four
                case 'ZERO_TO_FOUR':
                    eligibilityFormValues.ug_score_4 = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.ugGrade;
                    break;
                case 'CGPA':
                    eligibilityFormValues.ug_score_10 = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.ugGrade;
                    break;
                case 'PERCENTAGE':
                    eligibilityFormValues.ug_score_100 = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.ugGrade;
                    break;
                default:
                    eligibilityFormValues.ug_score_4 = undefined;
                    eligibilityFormValues.ug_score_10 = undefined;
                    eligibilityFormValues.ug_score_100 = undefined;
                    break;
            }
        }
        eligibilityFormValues.backlog = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.ugBacklogs;
        // [TODO]: Pg data is not beign sent to backend and not used any where. Need confirmation
        var englishExamType = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.englishExamType;
        eligibilityFormValues.englishExamGiven = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.englishExamGiven;
        if (isFalsy(englishExamType)) {
            eligibilityFormValues.englishExamMinBand = undefined;
            eligibilityFormValues.englishExamScore = undefined;
            eligibilityFormValues.englishExamType = undefined;
            eligibilityFormValues.englishExamComprehension = undefined;
            eligibilityFormValues.englishExamConversation = undefined;
            eligibilityFormValues.englishExamReading = undefined;
            eligibilityFormValues.englishExamWriting = undefined;
            eligibilityFormValues.englishExamSpeaking = undefined;
            eligibilityFormValues.englishExamListening = undefined;
            eligibilityFormValues.englishExamLiteracy = undefined;
            eligibilityFormValues.englishExamProduction = undefined;
            eligibilityFormValues.englishExamGiven = undefined;
        }
        else if (englishExamType === EnglishExamTestTypes.DUOLINGO) {
            eligibilityFormValues.englishExamType = EnglishExamTestTypes.DUOLINGO;
            eligibilityFormValues.englishExamScore = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.englishTotalScore;
            eligibilityFormValues.englishExamMinBand = CfEligibilityUtil.getMinScore([
                transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.literacy,
                transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.production,
                transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.comprehension,
                transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.conversation
            ]);
            eligibilityFormValues.englishExamComprehension = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.comprehension;
            eligibilityFormValues.englishExamConversation = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.conversation;
            eligibilityFormValues.englishExamLiteracy = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.literacy;
            eligibilityFormValues.englishExamProduction = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.production;
            eligibilityFormValues.englishExamGiven = true;
        }
        else {
            eligibilityFormValues.englishExamType = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.englishExamType;
            eligibilityFormValues.englishExamScore = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.englishTotalScore;
            eligibilityFormValues.englishExamMinBand = CfEligibilityUtil.getMinScore([
                transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.listening,
                transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.reading,
                transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.writing,
                transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.conversation
            ]);
            eligibilityFormValues.englishExamReading = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.reading;
            eligibilityFormValues.englishExamWriting = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.writing;
            eligibilityFormValues.englishExamSpeaking = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.speaking;
            eligibilityFormValues.englishExamListening = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.listening;
            eligibilityFormValues.englishExamGiven = true;
        }
        if (!isFalsy(transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.greGiven)) {
            eligibilityFormValues.greGiven = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.greGiven;
            eligibilityFormValues.greQuant = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.greQuant;
            eligibilityFormValues.greScore = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.greScore;
            eligibilityFormValues.greVerbal = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.greVerbal;
        }
        if (!isFalsy(transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.gmatGiven)) {
            eligibilityFormValues.gmatGiven = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.gmatGiven;
            eligibilityFormValues.gmatQuant = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.gmatQuant;
            eligibilityFormValues.gmatScore = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.gmatScore;
            eligibilityFormValues.gmatVerbal = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.gmatVerbal;
        }
        eligibilityFormValues.yearsOfEducation = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.yearsOfEducation;
        eligibilityFormValues.studentCountryId = Number.isNaN(Number(transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.studentCountryId))
            ? undefined
            : Number(transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.studentCountryId);
        eligibilityFormValues.studentStateId = Number.isNaN(Number(transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.studentStateId))
            ? undefined
            : Number(transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.studentStateId);
        eligibilityFormValues.universityNaac = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.universityNaac;
        eligibilityFormValues.twelfthBoardCode = (_a = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.twelfthBoardCode) === null || _a === void 0 ? void 0 : _a.toString();
        eligibilityFormValues.twelfthGraduationYear = isValidNumber(transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.twelfthGraduationYear)
            ? Number(transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.twelfthGraduationYear)
            : undefined;
        eligibilityFormValues.ugUniversityCode = (_b = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.ugUniversityCode) === null || _b === void 0 ? void 0 : _b.toString();
        eligibilityFormValues.moiAccepted =
            ((_c = transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.englishExamStatus) === null || _c === void 0 ? void 0 : _c.value) === EnglishExamStatusEnum.ENGLISH_EXAM_WAIVER ||
                (transformedEligibilityValues === null || transformedEligibilityValues === void 0 ? void 0 : transformedEligibilityValues.englishExamStatus) === EnglishExamStatusEnum.ENGLISH_EXAM_WAIVER
                ? 'true'
                : undefined;
        return eligibilityFormValues;
    };
    // Function not in use
    CfEligibilityUtil.getMinScore = function (scores) {
        var numberScores = scores
            .filter(function (score) { return !isFalsy(score) && !Number.isNaN(Number(score)); })
            .map(function (score) { return Number(score); });
        if (!isFalsy(numberScores)) {
            return Math.min.apply(Math, __spreadArray([], __read(numberScores), false));
        }
        else {
            return undefined;
        }
    };
    return CfEligibilityUtil;
}());
export { CfEligibilityUtil };
//# sourceMappingURL=CFEligibilityUtil.js.map